/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useTimer } from 'react-timer-hook';
import MAlert from '@material-ui/lab/Alert';
import styled from 'styled-components/macro';
interface ICountDownTimer {
  minutesIdle: number;
  secondTimeout: number;
  setUserIsActive: Function;
  setUserIsIdle: Function;
  isAutoUnassign: boolean;
}

const CountDownTimer = ({
  minutesIdle,
  secondTimeout,
  setUserIsActive,
  setUserIsIdle,
  isAutoUnassign,
}: ICountDownTimer) => {
  const time: Date = new Date(
    new Date().setSeconds(new Date().getSeconds() + secondTimeout),
  );
  const textTimer = useMemo(() => {
    return isAutoUnassign
      ? 'You will be unassigned in '
      : 'You will be redirected to Workdesk in';
  }, [isAutoUnassign]);
  const [openAlert, setOpenAlert] = useState(false);
  const { seconds, minutes, restart, start, pause } = useTimer({
    autoStart: false,
    expiryTimestamp: time,
    onExpire: () => setUserIsActive(false),
  });
  const handleOnIdle = () => {
    console.log('last active', getLastActiveTime());
    setUserIsIdle(true);
    setOpenAlert(true);
    start();
  };
  const handleOnActive = () => {
    console.log('time remaining', getRemainingTime());
    setOpenAlert(false);
    pause();
    setUserIsIdle(false);
    setUserIsActive(true);
    const timeRestart = new Date();
    timeRestart.setSeconds(timeRestart.getSeconds() + secondTimeout);
    restart(timeRestart, false);
  };
  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * minutesIdle,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
  });
  return (
    <SContainer>
      {openAlert && (
        <MAlert key={'alert'} severity={'error'}>
          {`${textTimer} ${
            `${minutes}`.length === 1 ? '0' : ''
          }${minutes}:${
            `${seconds}`.length === 1 ? '0' : ''
          }${seconds} minutes.`}
        </MAlert>
      )}
    </SContainer>
  );
};
export default CountDownTimer;
const SContainer = styled.div`
  position: fixed;
  right: 0;
  margin-top: 1vh;
  margin-right: 1vw;
  top: 0;
`;
